<template>
  <CContainer class="py-4">
    <CRow class="pageManageBalance">
      <CCol sm="12">
        <PageHeader class="border-0" title="manage-balance" pathName="home" TextPathName="GO_BACK_TO_DASHBOARD" />
      </CCol>
      <CCol sm="12" v-if="loading" class="vh-100">
        <div class="d-flex justify-content-center align-items-center" style="height: 30vh">
          <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
        </div>
      </CCol>
      <template v-else>
        <CCol sm="12" class="mb-2">
          <h3 class="font-weight-normal mt-2 pageManageBalance__campaignName">{{ organizationName }}</h3>
        </CCol>
        <CCol sm="12" class="mt-4">
          <CRow>
            <CCol sm="12" md="6" class="pr-4 pb-5">
              <h3 class="subtitlePage font-weight-normal">{{ $t('balance.component.currentBalance.title') }}</h3>
              <Balance :balances="totalsBalanceChannelsOrigin" :list="true" @channelSelected="channelSelected" />
            </CCol>
            <CCol sm="12" md="6" class="pl-4">
              <transition name="fade" v-if="channel == 2">
                <div>
                  <h3 class="subtitlePage font-weight-normal">{{ $t('balance.component.currentBalanceCountries.title') }}</h3>
                  <BalanceCountry :balances="balanceSMSOrigin" :value="channel" />
                </div>
              </transition>
            </CCol>
          </CRow>
        </CCol>

        <CCol sm="12" class="mt-5 mb-2">
          <h3 class="font-weight-normal mt-2 pageManageBalance__campaignName">
            {{ targetCompanyName }}
          </h3>
        </CCol>

        <CCol sm="12" class="mt-4">
          <WrapperTablesBalance :channel="channelName" />
        </CCol>
      </template>
    </CRow>
  </CContainer>
</template>

<script>
import PageHeader from '../components/PageHeader.vue'
import WrapperTablesBalance from '../components/manageBalance/WrapperTablesBalance.vue'
import Balance from '@/components/Balance.vue'
import BalanceCountry from '@/components/BalanceCountry.vue'
import services from '@/services.js'

const typeList = {
  email: 1,
  sms: 2,
}

export default {
  name: 'ManageBalanceDistributed',
  components: {
    Balance,
    BalanceCountry,
    PageHeader,
    WrapperTablesBalance,
  },

  data() {
    return {
      loading: false,
      organizationId: null,
      targetOrganizationId: false,
      organizationName: '',
      currentBalance: [],
      channel: 1,
      channelName: 'email',
      targetCompanyName: '',
      originOrganization: '',
    }
  },

  created() {
    this.loading = true
    this.organizationId = this.$route.params.organizationId
    this.targetOrganizationId = this.$route.params.targetOrganizationId || null
    this.originOrganizationId = this.$store.state.auth.session.organization?.organizationBaseId || ''
  },

  beforeDestroy() {
    this.$root.$off('update-close-popup')
  },

  mounted() {
    this.organizationId = this.$route.params.organizationId
    this.targetOrganizationId = this.$route.params.targetOrganizationId || null
    this.originOrganizationId = this.$store.state.auth.session.organization?.organizationBaseId || ''

    setTimeout(() => {
      this.getBalances()
      this.getNamesOrganization()
    }, 2000)
  },

  computed: {
    balanceSMSOrigin() {
      return this.$store.getters['backOffice/balanceSmsOrigin'] || []
    },

    totalsBalanceChannelsOrigin() {
      return this.$store.state.backOffice.totalsBalanceChannelsOrigin || []
    },
  },

  methods: {
    getBalances() {
      this.loading = true

      this.$store
        .dispatch('backOffice/getBalances', { targetOrganizationId: this.organizationId })
        .then((res) => {})
        .catch((res) => {})
        .finally(() => {
          this.loading = false
        })
    },

    getNamesOrganization() {
      this.loading = true

      services
        .getOrganization(this.targetOrganizationId || this.organizationId)
        .then((res) => {
          this.targetCompanyName = res.data.data.companyName
        })
        .catch((res) => {})
        .finally(() => {
          this.loading = false
        })

      if (this.targetOrganizationId) {
        this.Id = this.$store.state.auth.session.organization?.name || ''
        return
      }

      services
        .getOrganization(this.originOrganizationId)
        .then((res) => {
          this.organizationName = res.data.data.companyName
        })
        .catch((res) => {})
        .finally(() => {
          this.loading = false
        })
    },

    channelSelected(channel) {
      this.channel = typeList[channel] || null
      this.channelName = channel
    },
  },
}
</script>

<style lang="scss" scope>
.pageManageBalance__campaignName {
  border-bottom: 1px solid var(--gray-300);
  line-height: 1.5em;
}
</style>
